<template>
    <div class="search-overlay">
        <div class="container">

            <search-bar v-model="searchValue"></search-bar>

            <div class="header-3 font-family-2 fw-400 mt-lg-4 py-3 py-lg-0 text-center text-lg-start">
                {{recommendedPostsTitle}}
            </div>

            <recommended-posts :posts="posts"></recommended-posts>

        </div>
    </div>
</template>

<script>
import SearchBar from "./SearchBar";
import RecommendedPosts from "./RecommendedPosts";
import axios from "axios";

export default {
    name: "SearchOverlay",
    components: { RecommendedPosts, SearchBar },
    inject: ['restUri', 'recommendedPosts', 'localization'],
    data(){
        return {
            searchValue: "",
            searchTimeoutId: null,
            searchResultPosts: []
        }
    },
    methods: {
        async makeRequestForHints(){
            return axios.post(this.restEndpointUrl, {
                search: this.searchValue
            }).then(response => {
                this.searchResultPosts = response.data;
            }).catch(reason => {

            }).finally(() => {

            });
        }
    },
    watch: {
        searchValue(newValue, prevValue){

            if(newValue + "".trim() !== prevValue){

                //  Cancel any search.
                if(this.searchTimeoutId){
                    clearTimeout(this.searchTimeoutId);
                }

                this.searchResultPosts = [];

                if(newValue.length >= 3){

                    this.searchTimeoutId = setTimeout(() => {
                        this.makeRequestForHints();
                        this.searchTimeoutId = null;
                    }, 1000);
                }

            }

        }
    },
    computed: {
        restEndpointUrl(){
            return this.restUri + 'cccblog/v1/quicksearch/';
        },
        posts(){
            return this.searchResultPosts.length ? this.searchResultPosts : this.recommendedPosts;
        },
        recommendedPostsTitle(){
            return !this.searchResultPosts.length > 0 ? this.localization.recommendedArticles : this.localization.searchResultsSimilarTo + ' "' + this.searchValue + '"';
        }
    }
}
</script>

<style lang="scss" scoped>
    .search-overlay {

        @media screen and (max-width: 992px){
            position: relative;
            transform: none;
        }

        display: block;
        position: absolute;
        z-index: 10;
        width: 100%;
        bottom: 0;
        transform: translateY( 100% );
        background-color: white;
        padding: 8px 0;

    }
</style>